import React from 'react'
import { Paper, Text, Accordion } from '@mantine/core'
import { ThemeConfig } from '../../utils/themeConfig'

interface FAQSectionProps {
  themeConfig: ThemeConfig
}

export default function FAQSection({ themeConfig }: FAQSectionProps) {
  const faqs = [
    {
      question: '支付成功后如何查看报告？',
      answer:
        '支付成功后，您可以点击右侧"历史报告"按钮查看。由于短信可能延迟，建议支付成功后重新扫码进入当前页面，点击右侧绿色"查看报告"按钮即可立即查看。',
    },
    {
      question: '报告生成需要多长时间？',
      answer: '通常情况下，报告会在15-60秒内生成完成。如果超过10分钟仍未生成，请联系客服协助处理。',
    },
    {
      question: '可以申请退款吗？',
      answer: '如果付费后报告十分钟内未生成，或者对报告数据存在任何疑问，可点击右下角按钮联系客服咨询退款事宜。',
    },
    {
      question: '这是央行征信报告吗？',
      answer: '本报告非中国人民银行征信中心出具的个人征信报告，仅供参考使用。',
    },
  ]

  return (
    <Paper
      p="lg"
      radius="lg"
      style={{
        border: `1px solid ${themeConfig.surfaceBorderColor}`,
        background: themeConfig.surfaceColor,
      }}
    >
      <Text size="lg" fw={600} mb="md">
        常见问题
      </Text>
      <Accordion
        variant="separated"
        styles={{
          item: {
            border: `1px solid ${themeConfig.surfaceBorderColor}`,
            borderRadius: '8px',
            marginBottom: '8px',
          },
          control: {
            padding: '12px',
          },
          label: {
            fontSize: '14px',
            fontWeight: 500,
            color: themeConfig.accentTextColor,
          },
          content: {
            padding: '12px',
            fontSize: '13px',
            color: '#6B7280',
          },
        }}
      >
        {faqs.map((faq, index) => (
          <Accordion.Item key={index} value={`faq-${index}`}>
            <Accordion.Control>{faq.question}</Accordion.Control>
            <Accordion.Panel>{faq.answer}</Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion>
    </Paper>
  )
}
